import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4l10 16","key":"svg-0"}],["path",{"d":"M17 4l-10 16","key":"svg-1"}]]

const IconLetterX = createReactComponent('outline', 'letter-x', 'LetterX', __iconNode);

export default IconLetterX;